import { Action } from 'redux';
export interface ICityState {
  name: string; // We don't actually let the user change this...
  populationGrowthRate: number;
  economicGrowthRate: number;
  passengerDistanceTraveled: number;
  userChoicePercentageBound: number;
  hasMajorHills: boolean;
  hasCngRegulation: boolean;
  population: number;
  grossDomesticProduct: number;
  vehicleModalSplit: IModalSplit;
  vehicleOwnershipSplit: IOwnershipMode;
}

export enum VehicleType {
  car = 'car',
  twoWheel = 'twoWheel',
  threeWheel = 'threeWheel', // assume synonymous with autoRickshaw...
  publicTransit = 'publicTransit'
}
export type IModalSplit = {
  [key in VehicleType]: number;
}

export interface IOwnershipMode {
  [key: string]: IOwnershipModalSplit;
  car: ICarSplit;
  autoRickshaw: IAutorickshawSplit;
  twoWheel: ITwoWheelSplit;
  publicTransit: IPublicTransitSplit;
}

export interface IOwnershipModalSplit {
  [key: string]: number;
}

// Each Subcategory
export interface ICarSplit extends IOwnershipModalSplit {
  private: number;
  commercial: number;
  public: number;
}
export interface IAutorickshawSplit extends IOwnershipModalSplit {
  commercial: number;
}
export interface ITwoWheelSplit extends IOwnershipModalSplit {
  commercial: number;
  private: number;
}
export interface IPublicTransitSplit extends IOwnershipModalSplit {
  bus: number;
  metro: number;
}


export const enum CityActionTypes {
  SET_BOOLEAN_PROP = '@@city/SET_BOOLEAN_PROP',
  SET_NUMBER_PROP = '@@city/SET_NUMBER_PROP',
  SET_OBJECT_PROP = '@@city/SET_OBJECT_PROP',
}

export interface ISetCityNumberProp extends Action {
  type: CityActionTypes.SET_NUMBER_PROP;
  payload: {
    propName: string; // todo... replace with union of specific strings??
    value: number;
  };
}

export interface ISetCityBooleanProp extends Action {
  type: CityActionTypes.SET_BOOLEAN_PROP;
  payload: {
    propName: string;
    value: number;
  };
}

export interface ISetCityObjectProp extends Action {
  type: CityActionTypes.SET_OBJECT_PROP;
  payload: {
    propName: string;
    value: object;
  };
}

export type CityActions = ISetCityBooleanProp | ISetCityNumberProp | ISetCityObjectProp;

// Selector stuff
// Selectors for Projections



// WEBPACK FOOTER //
// ./src/store/types/city.ts